import api from '@/api';
import { API_BASE_URL } from '..';
import { ReportsGenerateCrmNextRevisionRequest } from './reports-generate.types';

const path = `${API_BASE_URL}/generate/crm`;

export async function getReportGenerateCrmNextRevision(
  params: ReportsGenerateCrmNextRevisionRequest,
) {
  const result = (await api.getReport(
    `${path}/next-revision`,
    params,
  )) as unknown;
  return result as Blob;
}
